export default __webpack_public_path__ + "static/assets/23105f656cb75909f8420346f631e8a1.png";